import omit from 'lodash/omit'
import isNil from 'lodash/isNil'
import { type StoreMetric } from 'domains/aggregate-store-performance/types/AggregateStorePerformance.types'

export const filterData = (data: StoreMetric[], fieldsToOmit: (keyof StoreMetric)[]) =>
  data.map(storeData => {
    const omittedData = omit(storeData, fieldsToOmit)
    Object.keys(omittedData).forEach(key => {
      omittedData[key] = isNil(omittedData[key]) ? 0 : omittedData[key]
    })
    return omittedData
  })
